import {
    ResourcePlannerActionTypes,
    SET_WEEK_COUNT,
    SET_RESOURCE_POSITIONS,
    SET_SELECTED_DAY,
    INCREMENT_START_DATE,
    GET_JOBPACKS,
    GET_TRACK_SUBJECTS,
    GET_TRACK_ORDER
} from "./types";
import moment, { Moment } from "moment";
export interface State {
    readonly weekCount: number;
    readonly trackOrder: Array<string>;
    readonly startDate: Moment;
    readonly jobpacks: any;
    readonly trackSubjects: any;
}

const INITIAL_STATE: State = {
    weekCount: 1,
    trackOrder: [],
    startDate: moment().startOf("isoWeek"),
    jobpacks: {},
    trackSubjects: {}
};

export default (state = INITIAL_STATE, action: ResourcePlannerActionTypes) => {
    switch (action.type) {
        case SET_WEEK_COUNT: {
            return { ...state, weekCount: action.payload };
        }
        case SET_RESOURCE_POSITIONS: {
            return { ...state, resourcePositions: action.payload };
        }
        case SET_SELECTED_DAY: {
            return { ...state, selectedDayIndex: action.payload };
        }
        case INCREMENT_START_DATE: {
            return { ...state, startDate: action.payload };
        }
        case GET_JOBPACKS: {
            return {
                ...state,
                jobpacks: action.payload
            };
        }
        case GET_TRACK_SUBJECTS: {
            return {
                ...state,
                trackSubjects: action.payload
            };
        }
        case GET_TRACK_ORDER: {
            return {
                ...state,
                trackOrder: action.payload
            };
        }
        default: {
            return state;
        }
    }
};
